import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { businessInfo } from '../../mockData';

const ContactInfoItem = ({ icon: Icon, title, children }) => (
  <div className="flex items-start space-x-3 sm:space-x-4">
    <div className="w-10 h-10 sm:w-12 sm:h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
      <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
    </div>
    <div>
      <h4 className="font-semibold text-gray-900 mb-1">{title}</h4>
      {children}
    </div>
  </div>
);

export const ContactInfo = () => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <ContactInfoItem icon={Phone} title="Phone">
        <a href="/call" className="text-gray-600 hover:text-primary">
          {businessInfo.phone}
        </a>
      </ContactInfoItem>

      <ContactInfoItem icon={Mail} title="Email">
        <a
          href={`mailto:${businessInfo.email}`}
          className="text-gray-600 hover:text-primary break-all"
        >
          {businessInfo.email}
        </a>
      </ContactInfoItem>

      <ContactInfoItem icon={MapPin} title="Service Area">
        <p className="text-gray-600">{businessInfo.serviceArea}</p>
        <p className="text-primary font-semibold mt-1">{businessInfo.hours}</p>
      </ContactInfoItem>
    </div>
  );
};
